import React from 'react';
import { LoaderSkeleton } from '@bloomays-lib/ui.shared';
import { styled } from '@mui/material/styles';

type IframeProps = {
  url: string | null;
};

const StyledIframe = styled('iframe')(({ theme }) => ({
  width: '100%',
  maxWidth: '100vw',
  minHeight: '82vh',
  height: '100%',
  border: 0,

  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

const Iframe = ({ url }: IframeProps) => {
  return (
    <div id="iframeElement">
      {!url ? (
        <LoaderSkeleton height={500} width={700} />
      ) : (
        <StyledIframe src={url} allow="encrypted-media" allowFullScreen></StyledIframe>
      )}
    </div>
  ) as React.ReactNode;
};

export default Iframe;
export { Iframe };
